<div class="spinner-container">
  <div
    class="spinner-border"
    role="status"
    [ngStyle]="{
      color: 'var(--primary-color)',
      width: spinnerSize,
      height: spinnerSize
    }"
  >
    <span class="sr-only">Loading...</span>
  </div>
</div>
